import { useRef } from 'react';
import { useSelector } from 'react-redux'
import { useParams, Link } from 'react-router-dom'

import StatusOptionsMulti from '../components/psc/lib/StatusOptionsMulti'
import SearchBox from '../components/psc/lib/SearchBox'
import GncDataTable from '../components/psc/lib/GncDataTable'
import Loading from '../components/psc/lib/Loading'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement';
import useTableSlots from '../hooks/useTableSlots'
import useProjectContents from '../hooks/useProjectContents'
import useRecordStatuses from '../hooks/useRecordStatuses'

const Records = () => {
    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    const isLoading = pscState.isLoading

    const table = useRef(null)
    const localStorageOrderKey = 'tblRecordsOrder'
    const defaultOrder = [[ 2, 'asc' ]]

    const { currentUser } = useAuthentication();

    const {
        userHasProjectAccessLevel,
        isUserManagementInitialized
    } = useUserManagement()

    const {
        isRecordsLoaded,
        records,
    } = useProjectContents()

    const {
        recordStatuses,
    } = useRecordStatuses()

    const {
        dateSlot,
        filePathSlot,
        linkSlot,
        ownerSlot
    } = useTableSlots()

    const columns = [
        { data: 'final_version_file_path' },
        { data: 'created_at' },
        { data: 'reference' },
        { data: 'title' },
        { data: 'std_document.name' },
        { data: 'owner_user_id' },
        { data: 'record_status.name' }
    ]

    const tableSlots = {
        0: filePathSlot,
        1: dateSlot,
        2: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/records/${row.id}`),
        3: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/records/${row.id}`),
        5: ownerSlot,
    }

    const type = project?.project_type?.name
    const tableHead = (
        <tr>
            <th style={{width: '25px'}}>&nbsp;</th>
            <th>Added</th>
            <th>Reference</th>
            <th>Title</th>
            <th>Type</th>
            <th>Owner</th>
            <th>Status</th>
        </tr>
    )
    
    const showLoading = isLoading || !isUserManagementInitialized || !isRecordsLoaded
    
    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        
                        <div className="ibox-title">
                            <h2>Records</h2>
                            
                            { project && userHasProjectAccessLevel(currentUser,project.id, 'MEMBER') &&
                              <Link type="button" className="btn btn-mr btn-primary" to={`/portfolio/${project.id}/records/new`}>New Record</Link>
                            }
            
                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                Records are <b>not version-controlled</b>. References are <b>automatically created</b>, based on this {type}'s configuration scheme.
                            </div>
                        </div>

                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="6"
                                    data={recordStatuses}
                                    localStorageKey="record-list-statuses"
                                />
                            </div>

                            { showLoading ? <Loading /> : (
                                <GncDataTable
                                    tableRef={table}
                                    data={records}
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Records
